import React from 'react';
import {
  JOB_STATUS_FAILED,
  JOB_STATUS_COMPLETED,
  JOB_STATUS_RUNNING,
} from 'scenes/jobs/constants';
import { JobItemStatus } from '../../types';
import { genRunningText, genCompleteText, jobStatusCellCss } from '../../utils';
import { JobStatusCellItem } from '../JobCellItem';
import './JobStatusCell.scss';

export interface JobStatusCellProps {
  status: JobItemStatus;
  progressRate?: number;
  errors?: string;
}

export const JobStatusCell: React.FC<JobStatusCellProps> = ({
  status,
  progressRate,
  errors,
}) => {
  const { jobCellCss, jobCellLoadingIcon } = jobStatusCellCss({
    errors: !!(errors?.length && errors?.length > 0),
    status,
  });

  return (
    <div className={jobCellCss}>
      {status === JOB_STATUS_RUNNING ? (
        <JobStatusCellItem
          customIconElement={<span className={jobCellLoadingIcon} />}
          status={status}
        >
          {genRunningText(progressRate)}
        </JobStatusCellItem>
      ) : null}

      {status === JOB_STATUS_COMPLETED ? (
        <JobStatusCellItem status={status} icon="TickColorless" errors={errors}>
          {genCompleteText(errors)}
        </JobStatusCellItem>
      ) : null}

      {status === JOB_STATUS_FAILED ? (
        <JobStatusCellItem
          status={status}
          icon="ErrorColorless"
          errors={errors}
        >
          Failed
        </JobStatusCellItem>
      ) : null}
    </div>
  );
};
